(() => {
  if (window.diosCategorySearchLoaded) return;
  window.diosCategorySearchLoaded = true;
  const requests = new Map();
  function load(url) {
    if (!requests.has(url)) requests.set(url, fetch(url, { credentials: 'omit' }).then(r => { if (!r.ok) throw new Error('Search unavailable'); return r.json(); }).catch(() => { throw new Error('Search is temporarily unavailable. Please refresh and try again.'); }));
    return requests.get(url);
  }
  const quote = value => '"' + value.replaceAll('\\', '\\\\').replaceAll('"', '\\"') + '"';
  function queryFor(scope, term) {
    const words = term.trim().split(/\s+/).filter(Boolean).slice(0, 12);
    const wordsQuery = words.map(word => 'title:' + quote(word)).join(' AND ');
    return [scope.query, wordsQuery && '(' + wordsQuery + ')'].filter(Boolean).join(' AND ');
  }
  function resolveKey(root, scopes, current) {
    const requested = current.searchParams.get('scope') || root.dataset.categoryKey || current.searchParams.get('browse');
    if (requested && scopes[requested]) return requested;
    const q = current.searchParams.get('q');
    return Object.keys(scopes).find(key => {
      const url = new URL(scopes[key].url, location.origin);
      return url.pathname === current.pathname && url.searchParams.get('q') === q;
    });
  }
  function hidden(form, name, value) {
    let input = form.querySelector('input[name="' + name + '"]');
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.append(input); }
    input.value = value;
  }
  async function results(root, scopes, key, current) {
    const productRoot = root.closest('[data-dios-products]');
    if (!productRoot || productRoot.dataset.scopedSearch !== 'true') return;
    const scope = scopes[key];
    const term = (current.searchParams.get('term') || '').trim().slice(0, 100);
    if (!scope || !term || current.searchParams.get('q') !== queryFor(scope, term)) throw new Error('Please search again using the category search field.');
    root.querySelector('input[type="search"]').value = term;
    root.querySelector('[data-category-search-label]').textContent = 'Search in ' + scope.title;
    productRoot.querySelector('[data-browse-title]').textContent = scope.title;
    document.title = term + ' in ' + scope.title + ' – Dio’s Treasures';
    const crumbs = productRoot.querySelector('[data-browse-crumbs]'); crumbs.replaceChildren();
    for (const [label, url] of [['Shop by category', '/collections?view=dios-shop'], [scope.title, scope.url], ['Search results', null]]) {
      const li = document.createElement('li'), item = document.createElement(url ? 'a' : 'span'); item.textContent = label;
      if (url) item.href = url; else item.setAttribute('aria-current', 'page'); li.append(item); crumbs.append(li);
    }
    const clear = root.querySelector('[data-category-search-clear]'); clear.href = scope.url; clear.textContent = 'Clear search'; clear.hidden = false;
    const allowed = new Set(scope.types.map(type => type.toLocaleLowerCase('en-US')));
    const container = productRoot.querySelector('[data-category-results]');
    let kept = 0, removed = 0;
    for (const card of container.querySelectorAll('.product-grid > li')) {
      if (allowed.has((card.dataset.productType || '').toLocaleLowerCase('en-US'))) kept++;
      else { card.remove(); removed++; }
    }
    const paging = [...container.querySelectorAll('[data-browse-pagination] a')];
    for (const link of paging) {
      const target = new URL(link.href, location.origin);
      for (const [name, value] of [['view', 'dios-scoped'], ['scope', key], ['browse', key], ['term', term], ['q', queryFor(scope, term)], ['type', 'product']]) target.searchParams.set(name, value);
      if (current.searchParams.has('sort_by')) target.searchParams.set('sort_by', current.searchParams.get('sort_by'));
      link.href = target.pathname + target.search + target.hash;
    }
    const pageNumber = Number(current.searchParams.get('page') || 1);
    const hasNext = paging.some(link => Number(new URL(link.href).searchParams.get('page')) > pageNumber);
    productRoot.querySelector('[data-product-count]').textContent = kept + (kept === 1 ? ' matching product' : ' matching products') + (paging.length || pageNumber > 1 ? ' on this page' : '');
    root.querySelector('[data-category-search-status]').textContent = 'Results for “' + term + '” in ' + scope.title + '.';
    const sort = productRoot.querySelector('[data-browse-sort]');
    for (const [name, value] of [['view', 'dios-scoped'], ['scope', key], ['browse', key], ['term', term], ['type', 'product'], ['q', queryFor(scope, term)]]) hidden(sort, name, value);
    if (!kept) {
      container.querySelector('.db-empty')?.remove();
      const empty = document.createElement('div'); empty.className = 'db-empty';
      const title = document.createElement('h2'); title.textContent = hasNext ? 'No matches on this page' : 'No matching products';
      const text = document.createElement('p'); text.textContent = hasNext ? 'Try another keyword or continue to the next page.' : 'Try a shorter name or another keyword, or clear the search to browse this category.';
      const link = document.createElement('a'); link.href = scope.url; link.textContent = 'Browse ' + scope.title;
      empty.append(title, text, link); container.prepend(empty);
    }
    container.hidden = false;
  }
  function initialize(root) {
    if (root.dataset.searchReady) return;
    root.dataset.searchReady = 'true';
    const form = root.querySelector('form'), input = form.querySelector('input[type="search"]'), button = form.querySelector('button');
    const current = new URL(location.href), productRoot = root.closest('[data-dios-products]');
    const owner = productRoot || root.parentElement.querySelector('[data-fast-browse], [data-dios-browse-page]');
    const heading = owner?.querySelector('.df-heading, .db-heading, .db-hero');
    const title = heading?.querySelector('h1')?.textContent.trim();
    if (heading) heading.insertAdjacentElement('afterend', root);
    const label = root.querySelector('[data-category-search-label]');
    label.textContent = 'Search ' + (root.dataset.categoryKey === 'shop' ? 'all products' : 'in ' + (title || 'this category'));
    // dios-browse.js replaces the raw page title once the routes file loads; keep the label in step with it.
    const titleEl = heading?.querySelector('h1');
    if (titleEl && root.dataset.categoryKey !== 'shop') new MutationObserver(() => { const t = titleEl.textContent.trim(); if (t) label.textContent = 'Search in ' + t; }).observe(titleEl, { childList: true, characterData: true, subtree: true });
    input.disabled = false; button.disabled = false;
    input.addEventListener('focus', () => { load(root.dataset.scopesUrl).catch(() => {}); }, { once: true });
    let busy = false;
    form.addEventListener('submit', async event => {
      event.preventDefault(); if (busy) return;
      const term = input.value.trim().slice(0, 100);
      if (!term) { input.focus(); return; }
      busy = true; button.disabled = true;
      const status = root.querySelector('[data-category-search-status]'); status.textContent = 'Searching…';
      try {
        const scopes = await load(root.dataset.scopesUrl), key = resolveKey(root, scopes, current), scope = scopes[key];
        if (!scope) throw new Error('Category search is unavailable here. Please choose a category from Browse all.');
        const target = new URL('/search', location.origin);
        for (const [name, value] of [['type', 'product'], ['view', 'dios-scoped'], ['scope', key], ['browse', key], ['term', term], ['q', queryFor(scope, term)]]) target.searchParams.set(name, value);
        location.assign(target.pathname + target.search);
      } catch (error) { status.textContent = error.message || 'Search is temporarily unavailable. Please try again.'; button.disabled = false; busy = false; }
    });
    if (productRoot?.dataset.scopedSearch === 'true') {
      load(root.dataset.scopesUrl).then(scopes => results(root, scopes, resolveKey(root, scopes, current), current)).catch(error => {
        root.querySelector('[data-category-search-status]').textContent = error.message || 'Search is temporarily unavailable. Please try again.';
        productRoot.querySelector('[data-product-count]').textContent = 'Search unavailable';
      });
    }
  }
  const boot = () => document.querySelectorAll('[data-category-search]').forEach(initialize);
  boot(); document.addEventListener('shopify:section:load', boot);
})();
